import CreateEventFormBasicInfo from './createEventFormBasicInfo';

export default CreateEventFormBasicInfo;
